module.exports = __webpack_public_path__ + "img/anim.e6b379ff.svg";